// extracted by mini-css-extract-plugin
module.exports = {"container":"cv_x","paragraph":"cv_h3"};